import React from 'react';
import isBrowser from '../../util/isBrowser';
import ButtonDataVariantDebugGlobalStyles from './ButtonDataVariantDebugGlobalStyles';
import { DebugFlags, useDebugFlag } from './debugFlag';

/**
 * Applies data-variant highlight styles when that debug flag is on.
 * Mount from `<Command />` (behind `<Debug>`).
 */
export default function DebugHelper() {
  const shown = useDebugFlag(DebugFlags.ButtonVariant);

  if (!isBrowser) {
    return null;
  }

  return <ButtonDataVariantDebugGlobalStyles enabled={shown} />;
}
